<template>
  <div>
    <el-form :disabled="disabled" label-position="top">
      <el-row>
        <el-col :span="12">
          <div class="block" style="width:270px;height:240px;">
            <el-image
              style="width: 100%; height: 100%"
              :src="imageUrl"
              :preview-src-list="[imageUrl]"
            >
              <div
                slot="error"
                class="image-slot upload-error-slot"
                style="text-align: center"
                @click="buttonClike()"
              >
                <i class="el-icon-plus" style="font-size:70px"></i>
              </div>
            </el-image>
          </div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="回单说明">
            <el-input
              placeholder="请输入回单说明"
              type="textarea"
              :rows="9"
              v-model="podData.podRemarks"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-upload
        ref="upload"
        action="/store/oss/upload"
        :auto-upload="false"
        :show-file-list="false"
        :multiple="false"
        :http-request="uploadFile"
        :on-change="onUploadChange"
      >
        <el-button
          id="uploadButtom"
          size="small"
          type="primary"
          v-if="!disabled"
          >选取回单</el-button
        >
      </el-upload>
    </el-form>
    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="sumitFile()" type="primary" size="small"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    code: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isAdd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      backDialogVisible: false,
      podData: {
        imageUrl: '',
        podRemarks: '',
        waybillCode: this.code,
      },
      imageUrl: '',
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    buttonClike() {
      document.getElementById('uploadButtom').click()
    },
    onUploadChange(file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    getData() {
      this.$api
        .carriageWaybillPODDetailApi({ waybillCode: this.code })
        .then((res) => {
          this.podData = res.body || {}
          this.imageUrl = this.$osscdn(this.podData.imageUrl)
        })
    },
    async save() {
      if (!this.imageUrl) {
        this.$message({
          message: '请选取POD回单图片',
          type: 'warning',
        })
        return
      }
      this.podData.waybillCode = this.code
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api.carriageWaybillPODSaveApi(this.podData).then((res) => {
         loadingInstance.close()
        this.$message({
          showClose: true,
          message: res.msg,
          type: 'success',
        })
        this.$emit('close')
      }).catch(() => {
          loadingInstance.close()
        })
    },
    sumitFile() {
      this.$refs.upload.submit()
      if (
        !this.$refs.upload.uploadFiles ||
        this.$refs.upload.uploadFiles.length === 0
      ) {
        this.save()
      }
    },
    uploadFile(params) {
      this.$api
        .SYS_UPLOAD(params.file)
        .then((res) => {
          this.podData.imageCode = res.body.id
          this.podData.imageUrl = res.body.url
          this.save()
        })
        .catch((e) => {
          console.log('POD回单上传失败 ==> ', e)
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss">
.upload-error-slot {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  width: 240px;
  height: 240px;
  line-height: 275px;
  text-align: center;
}
</style>
